module.exports.colors = {
  colorBadgeSuccess: '#1151e1',
  colorBadgeSuccessLight: '#e8eefe',
  colorBadgeAlert: '#c04550',
  colorBadgeAlertLight: '#fdeeef',
  colorBadgeAlertLightText: '#6b242a',
  colorBadgeInfo: '#076b76',
  colorBadgeInfoLight: '#e0f6f9',
  colorBadgeExpose: '#b58612',
  colorBadgeExposeLight: '#fcf6e8',
  colorBadgeExposeLightText: '#88640e',
  colorBadgeMuted: '#1a253d',
  colorBadgeMutedLight: '#f5f6fa',
  colorCoralDark: '#b24748',
  colorCoral: '#ff6668',
  colorCoralPastel: '#ffefef',
  colorPinkDark: '#b28085',
  colorPink: '#f89099',
  colorPinkPastel: '#fff7f8',
  colorYellowDark: '#b28e35',
  colorYellow: '#ffcb4d',
  colorYellowPastel: '#fff9ed',
  colorGoldDark: '#726d40',
  colorGold: '#d6cf8d',
  colorGoldPastel: '#f7f5e6',
  colorBlueDark: '#1347c1',
  colorBlue: '#1859f1',
  colorBluePastel: '#e1ecff',
  colorNavyDark: '#0d1e44',
  colorNavy: '#071948',
  colorNavyPastel: '#e7efff',
  colorTealDark: '#0b8a90',
  colorTeal: '#11c6cf',
  colorTealPastel: '#e7f9fa',
  colorWhite: '#fff',
  colorGrey98: '#f8f8fa',
  colorGrey95: '#f3f4f6',
  colorGrey90: '#e6e8ed',
  colorGrey70: '#b5bac8',
  colorGrey40: '#838ca3',
  colorGrey30: '#515e7f',
  colorGrey20: '#36456b',
  colorBlack: '#000',
  colorFacebook: '#1877F2',
  colorTwitter: '#00A7F1',
};
